import axios from "axios";
import fetch from "../utils/fetch";
import { returnErrors, createMessage } from "./messages";
import {
  USER_LOADED,
  USER_LOADING,
  AUTH_ERROR,
  LOGIN_FAIL,
  CHANGE_AVATAR,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  UPDATE_PASSWORD_BY_MOBILE_FAIL,
  UPDATE_PASSWORD_BY_MOBILE_SUCCESS,
  MENU_LOADER,
} from "./types";


// CHECK TOKEN & LOAD USER
export const loadUser = () => (dispatch, getState) => {
  // User Loading
  dispatch({ type: USER_LOADING });

  axios
    .get("/api/auth/user", tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: USER_LOADED,
        payload: res.data,
      });
    })
    .catch((err) => {
      console.log(11122, err, err.response)
      dispatch({
        type: AUTH_ERROR,
      });
      dispatch(returnErrors(err.response.data, err.response.status));
    });
};



// LOGIN USER
export const login = (username, password) =>  {
  return fetch({
    url: "/api/auth/login",
    method: "post",
    data: { username, password },
  });
};
// companyList
export const getCompanyList = (token) =>  {
  return fetch({
    url:  "/user_com/get_applications_by_user/",
    method: "get",
    data: {},
    headers: {
      Authorization: "Bearer " + token,
    },
  });
};
// getMenuList
export const getMenuList = (data) =>  {
  return fetch({
    url:  "/app_menu1/get_menu_by_application_id/",
    method: "post",
    data,
    headers: {
      Authorization: "Bearer " + localStorage.access,
    },
  });
};

export const loadMenu = (menuList) => (dispatch) => {
  dispatch({
    type: MENU_LOADER,
    menuList
  })
}

// doLogin
export const doLogin = (isSuccess, res) => (dispatch) => {
  if (isSuccess) {
    dispatch({
      type: LOGIN_SUCCESS,
      payload: res,
    });
  } else {
    dispatch(returnErrors(res.detail, 401));
    dispatch({
      type: LOGIN_FAIL,
    });
  }
};

// REGISTER USER
export const register =
  (username, company_name, password, email, mobile, code) => (dispatch) => {
    // Headers
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // Request Body
    const body = JSON.stringify({
      username,
      company_name,
      password,
      email,
      mobile,
      code,
    });

    axios
      .post("/api/auth/register", body, config)
      .then((res) => {
        dispatch({
          type: REGISTER_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch(returnErrors(err.response.data, err.response.status));
        dispatch({
          type: REGISTER_FAIL,
        });
      });

    const body1 = JSON.stringify({ email, username });

    axios
      .post("/api/verifications/fetch_email_code", body1, config)
      .then((res) => {
        console.log(res.data.message);
      })
      .catch((err) => {
        dispatch(returnErrors(err.response.data, err.response.status));
      });
  };

//  RESET PASSWORD
export const resetPassword = (mobile, code, password) => (dispatch) => {
  // Headers
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  // Request Body
  const body = JSON.stringify({
    password,
    mobile,
    code,
  });

  axios
    .put("/api/auth/reset_pw_by_phone", body, config)
    .then((res) => {
      dispatch({
        type: UPDATE_PASSWORD_BY_MOBILE_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(returnErrors(err.response.data, err.response.status));
      dispatch({
        type: UPDATE_PASSWORD_BY_MOBILE_FAIL,
      });
    });
};

//  RESET PASSWORD BY OLD PASSWORD
export const resetPasswordByOldPassword =
  (password, newPassword) => (dispatch, getState) => {
    // Request Body
    const body = { password, newPassword };

    axios
      .put("/api/auth/reset_pw_by_password", body, tokenConfig(getState))
      .then((res) => {
        dispatch(
          createMessage({
            resetPasswordSuccess: "密码修改成功",
          })
        );
      })
      .catch((err) => {
        dispatch(returnErrors(err.response.data, err.response.status));
      });
  };

//  RESET MOBILE BY OLD PASSWORD
export const resetMobileByPassword =
  (password, mobile, code) => (dispatch, getState) => {
    const body = { password, mobile, code };

    axios
      .put("/api/auth/reset_mobile_by_password", body, tokenConfig(getState))
      .then((res) => {
        dispatch(
          createMessage({
            resetMobileSuccess: "手机号修改成功",
          })
        );
      })
      .catch((err) => {
        dispatch(returnErrors(err.response.data, err.response.status));
      });
  };

// LOGOUT USER
export const logout = () => (dispatch, getState) => {
  axios
    .get("/api/auth/logout", tokenConfig(getState))
    .then(() => {
      dispatch({
        type: LOGOUT_SUCCESS,
      });
    })
    .catch((err) => {
      dispatch(returnErrors(err.response.data, err.response.status));
    });
};
export const changeAvatar = (avatar) => (dispatch) => {
  dispatch({
    type: CHANGE_AVATAR,
    avatar: avatar
  });
};

// Setup config with token -helper function
export const tokenConfig = (getState) => {
  // Get access token from state
  const access = getState().auth.access;

  // Headers
  const config = {
    headers: {},
  };

  // If access, add to headers config
  if (access) {
    config.headers["Authorization"] = `Bearer ${access}`;
  }

  return config;
};


// 通过邮箱重置密码
export const resetPasswordByEmail = (params) =>  {
  return fetch({
    url: "/api/auth/reset_pw_by_email",
    method: "PUT",
    data: params,
  });
};

// 重置密码成功-邮箱
export const resetPasswordSuccess = (res) => (dispatch) => {
  dispatch({
    type: UPDATE_PASSWORD_BY_MOBILE_SUCCESS,
    payload: res,
  });
}